export async function refreshCognitoTokens(refreshToken) {
	const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
	const domain = process.env.REACT_APP_COGNITO_DOMAIN; // e.g. reservasinfila.auth.us-east-1.amazoncognito.com

	const res = await fetch(`https://${domain}/oauth2/token`, {
		method: "POST",
		headers: { "Content-Type": "application/x-www-form-urlencoded" },
		body: new URLSearchParams({
			grant_type: "refresh_token",
			client_id: clientId,
			refresh_token: refreshToken,
		}),
	});

	if (!res.ok) throw new Error("Failed to refresh tokens");
	const data = await res.json();
	return {
		access_token: data.access_token,
		id_token: data.id_token,
		refresh_token: data.refresh_token || refreshToken, // reuse old if not returned
	};
}

// export async function refreshCognitoTokens(refreshToken) {
// 	const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
// 	const domain = process.env.REACT_APP_COGNITO_DOMAIN;

// 	const res = await fetch(`https://${domain}/oauth2/token`, {
// 		method: "POST",
// 		headers: {
// 			"Content-Type": "application/x-www-form-urlencoded",
// 		},
// 		body: new URLSearchParams({
// 			grant_type: "refresh_token",
// 			client_id: clientId,
// 			refresh_token: refreshToken,
// 		}),
// 	});

// 	if (!res.ok) {
// 		throw new Error("Token refresh failed");
// 	}

// 	const data = await res.json();

// 	return {
// 		accessToken: data.access_token,
// 		idToken: data.id_token,
// 		refreshToken: data.refresh_token || refreshToken,
// 	};
// }
